import React from 'react';

function SettingIconV3({ fill, className }) {
  return (
    <svg
      className={className}
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.75 28.4375H11.25C4.4625 28.4375 1.5625 25.5375 1.5625 18.75V11.25C1.5625 4.4625 4.4625 1.5625 11.25 1.5625H18.75C25.5375 1.5625 28.4375 4.4625 28.4375 11.25V18.75C28.4375 25.5375 25.5375 28.4375 18.75 28.4375ZM11.25 3.4375C5.4875 3.4375 3.4375 5.4875 3.4375 11.25V18.75C3.4375 24.5125 5.4875 26.5625 11.25 26.5625H18.75C24.5125 26.5625 26.5625 24.5125 26.5625 18.75V11.25C26.5625 5.4875 24.5125 3.4375 18.75 3.4375H11.25Z"
        fill={`${fill}`}
      />
      <path
        d="M19.4751 24.0625C18.9626 24.0625 18.5376 23.6375 18.5376 23.125V18.25C18.5376 17.7375 18.9626 17.3125 19.4751 17.3125C19.9876 17.3125 20.4126 17.7375 20.4126 18.25V23.125C20.4126 23.6375 19.9876 24.0625 19.4751 24.0625Z"
        fill={`${fill}`}
      />
      <path
        d="M19.4751 10.25C18.9626 10.25 18.5376 9.825 18.5376 9.3125V6.875C18.5376 6.3625 18.9626 5.9375 19.4751 5.9375C19.9876 5.9375 20.4126 6.3625 20.4126 6.875V9.3125C20.4126 9.825 19.9876 10.25 19.4751 10.25Z"
        fill={`${fill}`}
      />
      <path
        d="M19.4751 16.75C17.1626 16.75 15.2876 14.875 15.2876 12.5625C15.2876 10.25 17.1626 8.375 19.4751 8.375C21.7876 8.375 23.6626 10.25 23.6626 12.5625C23.6626 14.875 21.7751 16.75 19.4751 16.75ZM19.4751 10.25C18.2001 10.25 17.1626 11.2875 17.1626 12.5625C17.1626 13.8375 18.2001 14.875 19.4751 14.875C20.7501 14.875 21.7876 13.8375 21.7876 12.5625C21.7876 11.2875 20.7376 10.25 19.4751 10.25Z"
        fill={`${fill}`}
      />
      <path
        d="M10.5249 24.0625C10.0124 24.0625 9.5874 23.6375 9.5874 23.125V20.6875C9.5874 20.175 10.0124 19.75 10.5249 19.75C11.0374 19.75 11.4624 20.175 11.4624 20.6875V23.125C11.4624 23.6375 11.0499 24.0625 10.5249 24.0625Z"
        fill={`${fill}`}
      />
      <path
        d="M10.5249 12.6875C10.0124 12.6875 9.5874 12.2625 9.5874 11.75V6.875C9.5874 6.3625 10.0124 5.9375 10.5249 5.9375C11.0374 5.9375 11.4624 6.3625 11.4624 6.875V11.75C11.4624 12.2625 11.0499 12.6875 10.5249 12.6875Z"
        fill={`${fill}`}
      />
      <path
        d="M10.5249 21.625C8.2124 21.625 6.3374 19.75 6.3374 17.4375C6.3374 15.125 8.2124 13.25 10.5249 13.25C12.8374 13.25 14.7124 15.125 14.7124 17.4375C14.7124 19.75 12.8374 21.625 10.5249 21.625ZM10.5249 15.125C9.2499 15.125 8.2124 16.1625 8.2124 17.4375C8.2124 18.7125 9.2499 19.75 10.5249 19.75C11.7999 19.75 12.8374 18.7125 12.8374 17.4375C12.8374 16.1625 11.8124 15.125 10.5249 15.125Z"
        fill={`${fill}`}
      />
    </svg>
  );
}

export default SettingIconV3;
